import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bag-card',
  templateUrl: './bag-card.component.html',
  styleUrls: ['./bag-card.component.css']
})
export class BagCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
